/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { removeMaskForPhoneNumber, GetCardType } from './Helper/Helper';
import luhnValidateCreditCard from '../../../../Common/CreditCardValidation/CreditCardValidation';

const ValidationRules = {
    Phone: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        let inputVal = (data.value) ? data.value.toString() : '';
        inputVal = removeMaskForPhoneNumber(inputVal);
        const minLength = (data.min) ? data.min : data.max;
        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Invalid phone number';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Phone number is required';
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    ZipCode: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const value = data?.value || data?.val;
        const inputVal = value ? value.toString() : '';
        const minLength = (data.min) ? data.min : data.max;
        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Invalid Zip Code';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Zip Code is required';
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    Email: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const searchBrands = ['HD', 'WLF', 'SY'];
        const reg = /\S+@\S+\.\S+/;
        const inputVal = (data.value) ?  data.value.toString() : '';
        if ((!reg.test(inputVal) && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = (searchBrands.includes(data.getBrand.code)) ? 'Invalid E-Mail' : 'Invalid e-Mail Id';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = (searchBrands.includes(data.getBrand.code)) ? 'E-Mail is required' : 'e-Mail Id is required';
        } else if (data.validateWith) {
            const re = new RegExp(data.validateWith, 'i');
            if (inputVal.search(re) !== 0) {
                returnValid.flagError = true;
                returnValid.errorMessage = 'Email Confirmation is not matching';
            }
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    Password: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        // This is for check the password has the must be least 6 characters long with 1 number and 1 letter
        const reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d$&+,:;=?@#|'<>.^*()%!-{}[\]]{6,}$/;
        const inputVal = (data.value) ?  data.value.toString() : '';
        const minLength = (data.min) ? data.min : data.max;

        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Password must be least 6 characters long with 1 number and 1 letter';
        } else if ((!reg.test(inputVal) && inputVal.length > 0)) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Password must be least 6 characters long with 1 number and 1 letter';
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    MembershipNumber: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const inputVal = (data.value) ?  data.value.toString() : '';
        const minLength = (data.min) ? data.min : data.max;
        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Invalid Gift Card';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Gift Card is required';
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    GiftCard: (data, skip) => {
        const returnValid = {
            alert: false,
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const inputVal = (data.value) ?  data.value.toString() : '';
        const minLength = (data.min) ? data.min : data.max;
        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.alert = true;
            returnValid.flagError = true;
            returnValid.errorMessage = 'Invalid Gift Card';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = false;
            returnValid.alert = true;
            returnValid.errorMessage = '';
        } else {
            returnValid.alert = false;
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    /**
    GiftPin: (data, skip) => {
        const returnValid = {
            valid: true,
            errorMessage: '',
        };
        const inputVal = data.value;
        const minLength = (data.min) ? data.min : data.max;
        if (inputVal.length < minLength && inputVal.length > 0) {
            returnValid.valid = false;
            returnValid.errorMessage = 'Invalid Gift PIN';
        } else if (data.required && inputVal.length === 0) {
            returnValid.valid = false;
            returnValid.errorMessage = 'Gift PIN is required';
        } else {
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
     */
    CardNumber: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        let inputVal = (data.value) ?  data.value.toString() : '';
        inputVal = inputVal.split('-').join('');

        const checkCardValid = GetCardType(inputVal);
        if ((inputVal.length < checkCardValid.len && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Please Enter Full Card Number';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Card Number is required';
        } else if ((checkCardValid.cardType === '') && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'We are unable to process your order with this credit card. Please use MasterCard, Visa, American Express, or Discover.';
        } else if (inputVal.length >= checkCardValid.len && !luhnValidateCreditCard(inputVal)) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Please Enter A Valid Card Number';
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        returnValid.payload = checkCardValid;
        return returnValid;
    },
    CVV: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const inputVal = (data.value) ?  data.value.toString() : '';
        const minLength = (data.min) ? data.min : data.max;
        if ((inputVal.length < minLength && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'Please check your Card CVV Number';
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'CVV Number is required';
        } else {
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    IsYear: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const curYear = new Date().getFullYear();
        const shortCurYear = new Date().getFullYear().toString().substr(-2);
        const inputVal = (data.value) ?  data.value.toString() : '';
        if ((inputVal.length < 2 && inputVal.length > 0) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = `Invalid ${data.label}`;
        } else if ((inputVal.length === 4 && parseInt(inputVal, 10) < curYear) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = `Invalid ${data.label}`;
        } else if ((inputVal.length === 2 && parseInt(inputVal, 10) < shortCurYear) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = `Invalid ${data.label}`;
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = `${data.label} is required`;
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    IsMonth: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const exYear = data.validateWith;
        const curMonth = new Date().getMonth() + 1;
        const curYear = new Date().getFullYear();
        const shortCurYear = new Date().getFullYear().toString().substr(-2);
        const inputVal = (data.value) ?  data.value.toString() : '';
        if ((inputVal.length < 1) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = `Invalid ${data.label}`;
        } else if (((inputVal.length === 1 || inputVal.length === 2) && exYear.toString().length < 2 && !skip)) {
            if (parseInt(inputVal, 10) < 1 || parseInt(inputVal, 10) > 12) {
                returnValid.flagError = true;
                returnValid.errorMessage = `Invalid ${data.label}`;
            }
        } else if (((inputVal.length === 1 || inputVal.length === 2) && (exYear.toString().length === 4 || exYear.toString().length === 2)) && !skip) {
            if ((parseInt(inputVal, 10) < curMonth || parseInt(inputVal, 10) > 12) && (parseInt(exYear, 10) === curYear || parseInt(exYear, 10) === shortCurYear)) {
                returnValid.flagError = true;
                returnValid.errorMessage = `Invalid ${data.label}`;
            }
        } else if (data.required && inputVal.length === 0) {
            returnValid.flagError = true;
            returnValid.errorMessage = `${data.label} is required`;
        } else {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    Amount: (data, skip) => {
        const returnValid = {
            flagError: false,
            errorMessage: '',
            payload: {},
        };

        const inputVal = Number(data?.value) || 0;
        const minRedem = Number(data?.minRedem) || 0;
        const maxRedem = Number(data?.maxRedem) || 0;
        const totalRedem = Number(data?.totalRedem)?.toFixed(2) || 0;

        if ((inputVal < minRedem || inputVal > maxRedem || inputVal > totalRedem) && !skip) {
            returnValid.flagError = true;
            returnValid.errorMessage = 'You have crossed the redemption limit.';
        } else {
            returnValid.errorMessage = '';
        }

        return returnValid;
    },
    Mandatory: (data, skip) => {
        const returnValid = {
            alert: false,
            flagError: false,
            errorMessage: '',
            payload: {},
        };
        const value = data.val || data.value;
        let inputVal = '';
        if (value && value.trim()) {
            inputVal = value.toString();
        }
        if (data.required && inputVal.length === 0 && !skip) {
            returnValid.flagError = true;
            returnValid.alert = true;
            returnValid.errorMessage = `${data.label} is required`;
        }
        if (data.silent) {
            returnValid.flagError = false;
            returnValid.errorMessage = '';
        }
        return returnValid;
    },
    ValidateField: (validateAider, fieldName, skipOnChangeValidation) => {
        if (Object.prototype.hasOwnProperty.call(ValidationRules, validateAider.validateRule)) {
            const validatorFunction = ValidationRules[validateAider.validateRule];
            const validate = validatorFunction(validateAider, skipOnChangeValidation);
            return validate;
        }
        const validate = ValidationRules.Mandatory(validateAider, skipOnChangeValidation);
        return validate;
    },
};

export default ValidationRules;
